import { render, staticRenderFns } from "./AddReservation5.vue?vue&type=template&id=c2136846&scoped=true&"
import script from "./AddReservation5.vue?vue&type=script&lang=js&"
export * from "./AddReservation5.vue?vue&type=script&lang=js&"
import style0 from "./AddReservation5.vue?vue&type=style&index=0&id=c2136846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2136846",
  null
  
)

export default component.exports